/**
 * Creates a friendly name from a string by:
 * 1. Converting spaces to hyphens
 * 2. Removing all special characters
 * 3. Converting to lowercase
 *
 * Example:
 *  "Hello, World!" -> "hello-world"
 *  "123" -> "123"
 *  "" -> ""
 *  " " -> ""
 *  "!" -> ""
 *  " Hello, World! " -> "hello-world"
 *  "Hello!!! How are you?" -> "hello-how-are-you"
 *  "This is a test!" -> "this-is-a-test"
 */
export const createFriendlyName = (name: string): string => {

  if (!name) {
    throw new Error("[createFriendlyName] Missing name");
  }

  // Remove any leading or trailing whitespace
  name = name.trim();

  if (!name) {
    return "";
  }

  // Convert to lowercase
  let text = name.toLowerCase();

  // Normalize Unicode characters (converts accented characters to their basic form)
  text = text.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");

  // Convert spaces to hyphens
  text = text.replace(/\s+/g, "-");

  // Remove all special characters (keep only alphanumeric and hyphens)
  text = text.replace(/[^\w-]/g, "");

  // Remove any leading or trailing hyphens
  text = text.replace(/^-+|-+$/g, "");

  return text;
};
